import mixins from 'vue-typed-mixins';

import { 取込Api, 取込XlsxImportListItemResponse } from '@/openapi/user';

import Xlsxデータ確認Tab from '@/components/取込/データ確認/xlsx/Xlsxデータ確認Tab.vue';
import C取込Error from '@/components/取込/error/取込Error.vue';

import 取込Mixin from '@/entries/user/mixins/取込Mixin';
import UserApiUtility from '@/classes/common/UserApiUtility';

export default mixins(取込Mixin).extend({
  name: 'Xlsxデータ確認Dialog',

  components: {
    Xlsxデータ確認Tab,
    C取込Error,
  },

  props: {
    visible: {
      type: Boolean,
      default: false,
    },
  },

  data(): {
    xlsxImports: 取込XlsxImportListItemResponse[];
  } {
    return {
      xlsxImports: [],
    };
  },

  computed: {
    tabs(): string[] {
      return this.xlsxImports.map((取) => this.get取込データ種別Label(取.取込データ種別));
    },
    xlsxImport(): 取込XlsxImportListItemResponse | undefined {
      return this.xlsxImports[this.tabIndex()];
    },
    canSave(): boolean {
      return this.xlsxImports.length > 0;
    },
  },

  watch: {
    async visible(): Promise<void> {
      if (!this.visible || !this.importInfo.file) return;

      // 初期化
      this.setTabIndex(0, 0);
      this.xlsxImports = [];
      this.取込データ種別Errors = [];

      // 取込データ取得
      const response = await UserApiUtility.ogApi(取込Api).import取込Xlsx(
        this.計画書.pk,
        this.importInfo.取込分類,
        this.importInfo.file,
        this.importInfo.部門pk
      );

      // サーバー側の入力チェックエラーの場合はエラー表示してreturn
      if (this.is取込ValidationErrorResponse(response)) return;

      this.xlsxImports = response.data;
    },
  },

  methods: {
    close(): void {
      this.$emit('update:visible', false);
    },
    async save(): Promise<void> {
      await UserApiUtility.ogApi(取込Api).save取込Xlsx(
        this.計画書.pk,
        this.importInfo.取込分類,
        this.importInfo.部門pk
      );

      this.$emit('saved');
      this.close();
    },
  },
});
